export * from './Details';

import Details from './Details';
export default Details;
